module.exports = __webpack_public_path__ + "img/last.193095e2.svg";